import { configureStore } from "@reduxjs/toolkit";
import Sidebarslices from './Slices/SidebarSlices'
const store = configureStore({
    reducer:{
        sidebar:Sidebarslices
    }
})

export default store;